<template>
  <v-container>
    <table align="center" width="100%" bgcolor="#E0E0E0">
        <tbody>
        <tr>
            <td>
                <b>Paciente:</b>
                {{this.covidTracer.covid.name}}
            </td>
            <td>
                <b>Identificación:</b>
                {{this.covidTracer.covid.identification}}
            </td>
            <td>
                <b>Teléfono:</b>
            </td>
            <td>{{this.covidTracer.covid.phone}}</td>
        </tr>
        </tbody>
    </table>
    <v-layout>
      <v-card-text>
        <span  v-if="showSave">Ingrese los siguientes datos para su seguimiento.</span>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout>
            <v-flex xs12 sm10 offset-sm1>
              <v-data-table
                      :items="this.surveyDataList"
                      class="elevation-1"
                      hide-actions
                      hide-headers
              >
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">
                    <p  v-if="props.item.tipoPregunta=='Solo Texto'"
                        class="font-weight-bold">
                      {{props.item.pregunta}}</p>
                    <v-textarea
                            v-if="props.item.tipoPregunta=='Pregunta Abierta'"
                            :label="props.item.pregunta"
                            v-model="props.item.respuesta"
                            required
                    ></v-textarea>
                    <v-select
                            v-if="props.item.tipoPregunta=='Opciones'"
                            :items="props.item.tipoPreguntaData"
                            v-model="props.item.respuesta"
                            :label="props.item.pregunta"
                            required
                    ></v-select>
                  </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  No se han encontrado resultados para "{{ search }}".
                </v-alert>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-form>
        <div class="text-xs-center" :disabled="!valid">
          <router-link v-if="this.$store.state.seguimiento!=null && !isPatient" :to="{name: 'covidTracer'}" exact>Regresar a seguimientos</router-link>
          <v-btn color="primary" v-if="showSave" @click="saveData" dark>Guardar</v-btn>
        </div>
      </v-card-text>
    </v-layout>
    <v-dialog
            v-model="dialogError"
            max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span>Por favor verifique la información requerida para continuar.</span>
        </v-card-title>
        <v-card-actions>
          <v-btn
                  color="primary"
                  text
                  @click="dialogError = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
            v-model="dialogSuccess"
            max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span>Se guardó con exito la información</span>
          <span>Por su seguridad en unos segundos esta página se redireccionará a Inscora.</span>
        </v-card-title>
        <v-card-actions>
          <v-btn
                  color="primary"
                  text
                  @click="dialogSuccess = false"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>

  import CovidTracer from "../../model/CovidTracer";

  export default {
    data () {
      return {
        search: '',
        valid: false,
        requiredField:[v => !!v || 'Es requerido'],
        dialog: false,
        dialogError: false,
        dialogSuccess: false,
        opciones:[],
        editedIndex: -1,
        surveyData:{pregunta:"",tipoPregunta:"",tipoPreguntaData:[]},
        inputOpcion:"",
        surveyDataList:[],
        covidTracer: new CovidTracer(),
        covidTracerList: [],
        position:"",
        isPatient:false,
        showSave:true
      };
    },methods:{

      cleanData(){
        this.$refs.form.reset()
        this.covidTracer = new CovidTracer()
        this.valid = false
        this.dialog = false
      },

      saveData(){
          this.covidTracer.value = JSON.stringify(this.surveyDataList)
          this.covidTracer.date = new Date()
          this.covidTracer.covid = this.$store.state.covid
          this.covidTracer.token='TOKEN UTILIZADO'
          this.$store.dispatch('updateCovidTrace',this.covidTracer).then(response => {
            if(this.isPatient){
              setTimeout(() => {
                window.location.replace("https://www.inscorainc.com/");
                }, 6000);
            }else{
              this.reloadData()
            }
            this.dialogSuccess = true
          }, error => {
            this.$store.state.progress = false
            this.$store.state.dialogError = true
          })
          this.dialog= false
      },


      reloadData() {
        this.$store.dispatch('getCovidTraceListByCovidId',this.$store.state.covid.id).then(
                response => {
                  this.covidTracerList = this.$store.state.covidTraceList
                },
                error => {
                  this.$store.state.dialogError = true;
                }
        );
      },
      showPosition(position) {
        this.covidTracer.latitude=position.coords.latitude
        this.covidTracer.longitude=position.coords.longitude

      }
    },
      computed : {
      },
      created(){
        const token = this.$route.query.token
        if(token!=null){
          this.$store.dispatch('getCovidTraceByToken',token).then(
                  response => {
                    this.isPatient=true
                    if(response){
                      this.covidTracer=response
                      this.surveyDataList=JSON.parse(response.value)
                      this.$store.state.covid=response.covid
                      if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(this.showPosition);
                      } else {
                        x.innerHTML = "Geolocation is not supported by this browser.";
                      }
                    }else{
                      this.showSave=false
                    }
                  },
                  error => {
                    this.$store.state.dialogError = true;
                  }
          )
        }else{
          this.covidTracer=this.$store.state.seguimiento          
          this.surveyDataList=JSON.parse(this.$store.state.seguimiento.value)
          // if (navigator.geolocation) {
          //   navigator.geolocation.getCurrentPosition(this.showPosition);
          // } else {
          //   x.innerHTML = "Geolocation is not supported by this browser.";
          // }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/covid/CovidTracerResponse.vue